export default __webpack_public_path__ + "assets/peterGarretson.697c2ea4.png";